var React = require('react');

function IconAngleLeftInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"angle-left.inline"),React.createElement("path",{"d":"M6.91,143.1l136-136a23.9,23.9,0,0,1,33.9,0l22.6,22.7a23.9,23.9,0,0,1,0,33.9L103,160.1l96.5,96.3a23.9,23.9,0,0,1,0,33.9l-22.6,22.8a23.9,23.9,0,0,1-33.9,0L7,177.1A24.11,24.11,0,0,1,6.91,143.1Z","transform":"translate(0.05 -0.05)","key":1})]);
}

IconAngleLeftInline.defaultProps = {"viewBox":"0 0 206.61 320.1"};

module.exports = IconAngleLeftInline;

IconAngleLeftInline.default = IconAngleLeftInline;
